import { z } from 'zod';
import type { StaffRef } from './forms.js';

export const CANVAS_ACCOUNT_STATUSES = ['pending', 'created', 'failed'] as const;
export type CanvasAccountStatus = (typeof CANVAS_ACCOUNT_STATUSES)[number];

export interface CredentialsSummary {
  loginId: string;
  /** False once the password has been purged after the email went out. */
  passwordAvailable: boolean;
  generatedAt: string;
  generatedBy: StaffRef | null;
  canvasAccountStatus: CanvasAccountStatus;
  canvasAccountNote: string | null;
  emailedAt: string | null;
  purgedAt: string | null;
}

export const UpdateLoginSchema = z.object({ loginId: z.email().max(320) });
export const CanvasStatusSchema = z.object({
  status: z.enum(CANVAS_ACCOUNT_STATUSES),
  note: z.string().trim().max(1000).optional(),
});
